import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayS, LabelL } from '@sorare/core/src/atoms/typography';
import { ResponsiveImg } from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { glossary } from '@sorare/core/src/lib/glossary';

import { useNBAEvents } from '@sorare/gameplay/src/lib/events';

const Wrapper = styled(Vertical)`
  flex: 1;
  position: relative;
  align-items: center;
  gap: var(--double-unit);
  padding: var(--double-unit);
  justify-content: space-between;

  & > * {
    z-index: 1;
    position: relative;
  }
`;

const Card = styled(ResponsiveImg)`
  width: 65%;
  max-width: 270px;
  aspect-ratio: var(--card-aspect-ratio);
  pointer-events: none;
  user-select: none;
`;

type Props = {
  player?: unknown & {
    anyPlayer: { displayName: string };
    pictureUrl: string | null;
  };
  setStep: (step: number) => void;
};

export const ConfirmStarSelection = ({ player, setStep }: Props) => {
  const track = useNBAEvents();

  useEffect(() => {
    track('View Onboarding Star signing');
  }, [track]);

  return (
    <Wrapper>
      <Vertical>
        <DisplayS brand className="text-center">
          <FormattedMessage
            id="S3Onboarding.ConfirmStarSelection.title"
            defaultMessage="Star signing"
          />
        </DisplayS>
        <LabelL color="var(--c-neutral-700)" className="text-center">
          <FormattedMessage
            id="S3Onboarding.ConfirmStarSelection.subtitle"
            defaultMessage="{playerName} is yours!"
            values={{ playerName: player?.anyPlayer?.displayName }}
          />
        </LabelL>
      </Vertical>
      <Card src={player?.pictureUrl} alt="Player" cropWidth={320} />
      <Button
        fullWidth
        size="large"
        color="secondary"
        onClick={() => setStep(5)}
      >
        <FormattedMessage {...glossary.continue} />
      </Button>
    </Wrapper>
  );
};
